import { createSafeContext } from '@mantine/core';

type InfoListContext = {
  labelWidth?: number | string;
  setLabelWidth: React.Dispatch<React.SetStateAction<string | number | undefined>>;
  enableUniformLabelWidths: boolean;
  setLongestLabelWidth: (width: number) => void;
  longestLabelWidth: number;
};

export const [InfoListCardContextProvider, useInfoListCardContext] =
  createSafeContext<InfoListContext>('InfoListCard component was not found in tree');
